window.AsideEsquerda = {
    fixada: 'False',
    init: $(function () {
        AsideEsquerda.load();

    }),
    load: function () {
        var self = this;
        self.$tag = $("[aside-esquerda-action]");
        self.$tagBotoes = $('#menu-esquerdo');
        self.$body = $('body');

        if (self.fixada === 'True') {
            self.hide();
        } else {
            self.show();
        }

        self.$tag.click(function (e) {
            if ($(e.target).hasClass("ativo")) {
                self.hide();
                self.fixar(true);

            } else {
                self.show();
                self.fixar(false);

            }
        });
    },
    show: function() {
        var self = this;
        
        self.$tag.addClass("ativo");
        self.$tag.addClass("icone-pin-fixo");
        self.$body.addClass("sidebar-collapse");
        self.$tag.removeClass("icone-pin-suspenso");
        $("[menu-inicial-favorito]").hide();
        
        self.toggle();
    },
    hide: function() {
        var self = this;

        self.$body.removeClass("sidebar-collapse");
        self.$tag.removeClass("ativo");
        self.$tag.removeClass("icone-pin-fixo");
        self.$tag.addClass("icone-pin-suspenso");
        $("[menu-inicial-favorito]").show();
        
        self.toggle();
    },
    toggle: function () {
        var self = this;

        self.$tagBotoes.toggleClass('active');
    },
    fixar: function (fixar) {
        var self = this;

        global.ajax({
            url: '/Usuario/BarraLateralFixada',
            type: 'post',
            data: { fixada: fixar }
        });
    }
};
